import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";
import { dropdownItems } from "fixtureData/navCoinItems";
import "assets/styles/components/navbar.scss";

function DigitalCurecny() {
  const [search, setSearch] = useState<any>("");
  const [filter, setFilter] = useState<any>([]);
  const { t } = useTranslation();

  let dropdownItemsLocal = dropdownItems();

  const allFilter = filter.length ? filter : dropdownItemsLocal;
  return (
    <>
      <DropdownMenu className="w-100 end-0 bg-primary-one">
        <Row className="w-100 pt-4 pb-4 align-items-center">
          <Col xs="7" className=" text-end px-5">
            <span className="text-white ">
              {t(
                "View prices, charts, statistics and information, buy and sell guides and frequently asked questions about any digital currency"
              )}
            </span>
            <DropdownItem divider />
          </Col>
          <Col xs="5" className=" d-flex justify-content-end">
            <Form className="form-style">
              <InputGroup className="input-width ">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText className="border-radius-tr-1 border-radius-br-1">
                    <i className="icon-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={search}
                  onChange={(txt: any) => {
                    let filterd = dropdownItemsLocal.filter((item: any) => {
                      return t(item.title).indexOf(txt.target.value) >= 0;
                    });
                    setFilter(filterd);
                    setSearch(txt.target.value);
                  }}
                  type="text"
                  placeholder={t("Search currency name or symbol")}
                  className="fs-6 form-control-padding-y text-secondary-nine-light border-radius-tl-1 border-radius-bl-1 "
                />
              </InputGroup>
            </Form>
          </Col>
        </Row>
        <Row className="mx-1">
          {dropdownItemsLocal.length &&
            allFilter.map((item: any) => (
              <Col xs="2" className="my-1">
                <DropdownItem
                  className="pt-3 pb-3"
                  href={`/coins/${item.title?.toLowerCase()}`}
                >
                  <div className="d-flex ">
                    <img src={item.imgSrc} className="style-dropdown-icon" />
                    <span className="px-2"> {t(item.title)}</span>
                    <span> {t(item.symbol)}</span>
                  </div>
                </DropdownItem>
              </Col>
            ))}
        </Row>
      </DropdownMenu>
    </>
  );
}

export default DigitalCurecny;
